import { createAction } from 'redux-actions';

export const GET_NEWS = createAction('GET_NEWS');
export const GET_NEWS_START = createAction('GET_NEWS_START');
export const GET_NEWS_SUCCESS = createAction('GET_NEWS_SUCCESS');
export const GET_NEWS_ERROR = createAction('GET_NEWS_ERROR');
export const GET_NEWS_FINALLY = createAction('GET_NEWS_FINALLY');